import React from 'react'
import style from './paymentInfo.module.scss'
import { useSelector } from 'react-redux'
import cx from 'classnames'
import { Status } from '../../status/Status'
import { PaymentInfoHeader } from './PaymentInfoHeader'
import { useTranslation } from 'react-i18next'
import { PaymentInfoFooter } from './PaymentInfoFooter'

export const PurePaymentInfo = ({
	classname,
	paymentId,
	paymentStatusTranslation,
	isPaymentStatusFinal,
	hasBankList,
	lastDate,
	firstStatus,
	hasCorrespondBank,
	paymentStatusName
}) => {
	const { t } = useTranslation()
	return (
		<div className={cx(style.paymentInfo, classname)}>
			<PaymentInfoHeader
				paymentId={paymentId}
				statusLabel={
					paymentStatusTranslation && t('headerMainStatus' + paymentStatusTranslation)
				}
			/>
			<Status
				statusGroupName={paymentStatusName || 'SCHEDULED'}
				hasCorrespondBank={hasCorrespondBank}
			/>
			<PaymentInfoFooter
				isPaymentStatusFinal={isPaymentStatusFinal}
				hasBankList={hasBankList}
				firstDate={firstStatus?.emissionDate}
				isScheduled={firstStatus?.paymentStatus === 'SCHEDULED'}
				lastDate={lastDate}
			/>
		</div>
	)
}

/**
 * This component is smart and uses payment and Bank list datas
 */
export const PaymentInfo = () => {
	const { bankList, payment } = useSelector((state) => state.TrackerReducer)
	const hasCorrespondBank = payment?.carrier?.id !== 'INTERNAL'
	return (
		<PurePaymentInfo
			hasBankList={bankList?.length > 0}
			lastDate={bankList && bankList[bankList?.length - 1]?.lastEmissionDate}
			firstStatus={payment?.firstStatus}
			paymentId={payment?.id}
			paymentStatusTranslation={payment?.statusGroup.translation}
			isPaymentStatusFinal={payment?.statusGroup.isFinal}
			classname={cx('animate__animated', 'animate__fadeInLeft')}
			hasCorrespondBank={hasCorrespondBank}
			paymentStatusName={payment?.statusGroupName}
		/>
	)
}
